<template>
  <div class="gf-button-subscribe">
    <gf-button
      class="gf-button-subscribe__button"
      :class="{ '--starred': isStarredModel }"
      :before-icon="starIconClass"
      :variant="isStarredModel ? 'warning' : 'secondary'"
      :text="starText"
      :show-only-icon-mobile="true"
      @click="star"
    >
      <template #content>
        <span class="gf-button-subscribe__content">{{ formatOutputNumber(starsCountModel) }}</span>
      </template>
    </gf-button>
  </div>
</template>

<script>
import GfButton from '@shared/shared-components/shared/components/GfButton.vue';
import HelperS from '@shared/services/helper.service';

export default {
  components: { GfButton },
  name: 'GfButtonSubscribe',
  components: {
    GfButton
  },
  props: {
    starsCount: {
      default: 0
    },
    isStarred: {
      default: false
    }
  },
  data() {
    return {
      isStarredModel: false,
      starsCountModel: 0
    };
  },
  computed: {
    starIconClass() {
      return this.isStarredModel ? 'gf-icon-star-fill' : 'gf-icon-star';
    },
    starText() {
      return this.isStarredModel
        ? this.$t('message.star.starred')
        : this.$t('message.star.notStarred');
    }
  },
  mounted() {
    this.isStarredModel = this.isStarred;
    this.starsCountModel = this.starsCount || 0;
  },
  methods: {
    star() {
      if (this.isStarredModel) this.starsCountModel -= 1;
      else this.starsCountModel += 1;
      this.$emit('star', this.isStarredModel);
      this.isStarredModel = !this.isStarredModel;
    },
    formatOutputNumber(number) {
      return HelperS.formatOutputNumber(number, 0);
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-button-subscribe';

#{$this} {
  #{$this}__button {
    #{$this}__content {
      margin-left: 4px;
    }
  }
}
</style>
